import Dbm from "dbm";
import Website from "../../../index.js";

export default class SwitchableGraphics extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        
        let graphics = new Dbm.utils.NamedArray();
        this.item.setValue("graphics", graphics.item);

        this.item.setValue("currentGraphics", null)
        
    }

    addGraphics(aName, aLayer) {
        this.item.graphics.controller.addValue(aName, aLayer);

        if(!this.item.currentGraphics) {
            this.showGraphics(aName);
        }
    }

    showGraphics(aName) {
        if(this.item.currentGraphics) {
            this.item.pixiLayer.removeChild(this.item.currentGraphics);
        }

        let newGraphics = this.item.graphics.records[aName];
        if(newGraphics) {
            this.item.currentGraphics = newGraphics;
            this.item.pixiLayer.addChild(this.item.currentGraphics);

            if(this.item.currentGraphics.play) {
                this.item.currentGraphics.play();
            }
        }
        else {
            this.item.currentGraphics = null;
        }
        
    }

    update(aTime, aDelta) {

    }
}